import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import Curriculumleft from './Curriculumleft'


const Dualdegree_curriculumEle = () => {
    const curriculumData = [
        {
            department: "Interdisciplinary Dual Degree (IDDD) in Data Science",
            specializations: [
                {
                    name: "Interdisciplinary Dual Degree (IDDD) in Data Science",
                    curricula: [
                        {
                            batch: "2023 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2025/IDDD_DS_2023_Curriculum.pdf",
                        },
                    ],
                },
            ],
        },

        {
            department: "Chemical Engineering",
            specializations: [
                {
                    name: "Chemical Engineering",
                    curricula: [
                        {
                            batch: "2023 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2025/DD_CH_25.pdf",
                        },
                        {
                            batch: "2020 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/2025/DD_CH_24.pdf",
                        },
                    ],
                },
            ],
        },

        {
            department: "Civil and Environmental Engineering",
            specializations: [
                {
                    name: "Environmental and Water Resources Engineering",
                    curricula: [
                        {
                            batch: "2023 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2023/DD/DD_EWRE.pdf",
                        },
                        {
                            batch: "2019 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/DD/DD_EWRE.pdf",
                        },
                        {
                            batch: "2018 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/EWRE_2018_DD Curriculum.pdf",
                        },
                        {
                            batch: "2017 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/EWRE_2017_DD Curriculum.pdf",
                        },
                    ],
                },

                {
                    name: "Geotechnical Engineering",
                    curricula: [
                        {
                            batch: "2023 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2023/DD/DD_GTE.pdf",
                        },
                        {
                            batch: "2019 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/DD/DD_GTE.pdf",
                        },
                        {
                            batch: "2018 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/GT_2018_DD Curriculum.pdf",
                        },
                        {
                            batch: "2017 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/GT_2017_DD Curriculum.pdf",
                        },
                    ],
                },

                {
                    name: "Structural Engineering",
                    curricula: [
                        {
                            batch: "2023 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2023/DD/DD_SE.pdf",
                        },
                        {
                            batch: "2019 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/DD/DD_SE.pdf",
                        },
                        {
                            batch: "2018 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/SE_2018_DD Curriculum.pdf",
                        },
                        {
                            batch: "2017 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/SE_2017_DD Curriculum.pdf",
                        },
                    ],
                },

                {
                    name: "Transportation and Infrastructure Engineering",
                    curricula: [
                        {
                            batch: "2023 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2023/DD/DD_TIE.pdf",
                        },
                        {
                            batch: "2019 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/DD/DD_TIE.pdf",
                        },
                        {
                            batch: "2018 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/TIE_2018_DD Curriculum.pdf",
                        },
                        {
                            batch: "2017 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/TIE_2017_DD Curriculum.pdf",
                        },
                    ],
                },
            ],
        },

        {
            department: "Computer Science and Engineering",
            specializations: [
                {
                    name: "Computer Science and Engineering",
                    curricula: [
                        {
                            batch: "2024 Batch Onwards",
                            url: "https://files.iittp.ac.in/2026/academic/curriculum/Dual_Degree_MTech_CSE_2024_onwards.pdf",
                        },
                        {
                            batch: "2023 Batch Onwards",
                            url: "https://files.iittp.ac.in/2026/academic/curriculum/Dual_Degree_MTech_CSE_2023_onwards.pdf",
                        },
                        {
                            batch: "2018 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/DD/DD_CSE.pdf",
                        },
                        {
                            batch: "2017 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/CSE_2017_DD_Curriculum.pdf",
                        },
                    ],
                },

                {
                    name: "Data Science and Artificial Intelligence (DSAI)",
                    curricula: [
                        {
                            batch: "2024 Batch Onwards",
                            url: "https://files.iittp.ac.in/2026/academic/curriculum/Dual_Degree_DSAI_CSE_2024_onwards.pdf",
                        },
                        {
                            batch: "2023 Batch Onwards",
                            url: "https://files.iittp.ac.in/2026/academic/curriculum/Dual_Degree_DSAI_CSE_2023_onwards.pdf",
                        },
                    ],
                },
            ],
        },

        {
            department: "Electrical Engineering",
            specializations: [
                {
                    name: "Microelectronics & VLSI",
                    curricula: [
                        {
                            batch: "2023 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2025/Microelectronic_VLSI_DD_25.pdf",
                        },
                        {
                            batch: "2022 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/2025/Microelectronic_VLSI_DD.pdf",
                        },
                    ],
                },

                {
                    name: "RF & Microwave Engineering",
                    curricula: [
                        {
                            batch: "2023 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2025/RF_Microwave_DD_25.pdf",
                        },
                        {
                            batch: "2022 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/2025/RF_Microwave_DD.pdf",
                        },
                    ],
                },

                {
                    name: "Signal Processing, Communication and Machine Learning (SPCML)",
                    curricula: [
                        {
                            batch: "2023 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2025/DD_SPC_25.pdf",
                        },
                    ],
                },

                {
                    name: "Signal Processing and Communication",
                    curricula: [
                        {
                            batch: "2018 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/DD/DD_SPC.pdf",
                        },
                        {
                            batch: "2017 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/SPC_2017_DD_Curriculum.pdf",
                        },
                    ],
                },
            ],
        },

        {
            department: "Mechanical Engineering",
            specializations: [
                {
                    name: "Mechanical Engineering",
                    curricula: [
                        {
                            batch: "2023 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2023/DD/DD_ME_13-7-2023.pdf",
                        },
                        {
                            batch: "2018 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2022/DD/DD_ME_updated.pdf",
                        },
                        {
                            batch: "2017 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/dualdegree/ME_2017_DD Curriculum.pdf",
                        },
                    ],
                },

                {
                    name: "Computational Mechanics",
                    curricula: [
                        {
                            batch: "2023 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2025/ME_DD_Computational_Mechanics.pdf",
                        },
                    ],
                },

                {
                    name: "Design and Manufacturing",
                    curricula: [
                        {
                            batch: "2023 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2025/DD_DM_25.pdf",
                        },
                    ],
                },

                {
                    name: "Thermal Engineering and Energy Systems",
                    curricula: [
                        {
                            batch: "2023 Batch Onwards",
                            url: "https://files.iittp.ac.in/pdfs/curriculum/2025/DD_TEES_25.pdf",
                        },
                    ],
                },
            ],
        },
    ];

    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col md={4} className='c-left custom-padding-color mb-4'>
                        <Curriculumleft activeIndex={2} />
                    </Col>

                    <Col md={8} className='c-right mt-2 ps-5'>
                        <h3 className='text-center mb-5'>Dual Degree (B.Tech + M.Tech) Curriculum</h3>
                        <h5>Curriculum for Dual Degree Program are listed as below:</h5>
                        <table className="table table-bordered table-hover align-middle">
                            <thead className="table-primary text-center">
                                <tr>
                                    <th width="8%">S.No.</th>
                                    <th width="28%">Department</th>
                                    <th width="34%">Specialization</th>
                                    <th width="30%">Batch</th>
                                </tr>
                            </thead>

                            <tbody>
                                {curriculumData.map((dept, deptIndex) => {
                                    const departmentRowSpan = dept.specializations.reduce(
                                        (total, spec) => total + spec.curricula.length,
                                        0
                                    );

                                    return dept.specializations.flatMap((spec, specIndex) =>
                                        spec.curricula.map((item, itemIndex) => (
                                            <tr
                                                key={`${deptIndex}-${specIndex}-${itemIndex}`}
                                                className={
                                                    deptIndex % 2 === 0
                                                        ? "table-light"
                                                        : "table-secondary"
                                                }
                                            >
                                                {/* Department */}
                                                {specIndex === 0 && itemIndex === 0 && (
                                                    <>
                                                        <td
                                                            rowSpan={departmentRowSpan}
                                                            className="text-center align-middle fw-bold"
                                                        >
                                                            {deptIndex + 1}
                                                        </td>

                                                        <td
                                                            rowSpan={departmentRowSpan}
                                                            className="align-middle fw-bold"
                                                        >
                                                            {dept.department}
                                                        </td>
                                                    </>
                                                )}

                                                {/* Specialization */}
                                                {itemIndex === 0 && (
                                                    <td
                                                        rowSpan={spec.curricula.length}
                                                        className="align-middle"
                                                    >
                                                        {spec.name}
                                                    </td>
                                                )}

                                                {/* Batch */}
                                                <td>
                                                    <Link
                                                        to={item.url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-decoration-none"
                                                    >
                                                        <i className="fas fa-file-pdf text-danger me-2"></i>
                                                        {item.batch}
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))
                                    );
                                })}
                            </tbody>
                        </table>
                    </Col>
                </Row>
            </Container>
        </section>

    );
};


export default Dualdegree_curriculumEle;
